define(function (require) {
	const tpl = require('./templates/t_itv_checkbox_field.hbs');
	const baseElement = require('./v_itv_base_element');
	return baseElement.extend({
		template:tpl,
		templateHelpers:function(){
			//get baseElement Template Helpers
			var baseTH = baseElement.prototype.templateHelpers.apply(this);

			var self = this;
			var disabled = self.model.get('isEnabled') === false || self.config.readOnlyForm === true;
			var ret = {
				checked: self.model.get('value') && ( self.model.get('value').toString().toUpperCase() === 'TRUE' || self.model.get('value').toString().toUpperCase() === 'YES'),
				classes: 'checkbox-container' + 
						(self.model.get('isVisible') === false ? ' hidden' : '') + 
						(self.model.get('isEnabled') === true ? ' checkbox-enabled' : '') + 
						(self.model.get('fullWidthField') === true ? ' full-width' : ''),
				customAttr:function(){
					var ret = self.model.get('customAttr');
					if(self.config.isInGrid){
						ret += 'specialType="grid" ';
					}
					return ret;
				},
				disabled: disabled,
				text: this.options.isGrid ? '' : this.model.get('text'),
				labelClasses:'input-label',
				type:'checkbox'
			};

			ret = $.extend({},baseTH,ret);
			return ret;
		},
		getValue: function () {
			if (this.model.get('displayOnly') === true) {
				return;
			}
			if (this.model.get('isEnabled') === false || this.config.readOnlyForm) {
				//if we're disabled the value will be on the model.
				return this.model.get('value');
			}
			return this.$el.find('input').prop('checked');
		}
	});
});
